import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@mui/material';
import * as yup from 'yup';
import { useFormik } from 'formik';
import NoticeListBox from '../../../components/dashboard/notice/NoticeListBox';
import NoticeList from '../../../components/dashboard/notice/NoticeList';
import { listNotices, unloadNotices } from '../../../modules/dashboardModule/notices';

const NoticeListContainer = ({ selectedNotice }) => {
    const dispatch = useDispatch();
    const [searchKeyword, setSearchKeyword] = useState("wrTitle");
    const [searchWords, setSearchWords] = useState("");

    const { notices, error, loading } = useSelector(
        ({ dashboardModule, loading }) => ({
            notices: dashboardModule.notices.notices,
            error: dashboardModule.notices.error,
            loading: loading['dashboard/LIST_NOTICES'],
        }),
    );

    useEffect(() => {
        dispatch(listNotices());
    }, []);

    const searchList = (values) => {
        const searchData = {
            [values.searchKeyword]: values.searchWords
        }

        dispatch(listNotices(searchData));
        setSearchKeyword(values.searchKeyword);
        setSearchWords(values.searchWords);
    }

    const initialValues = {
        searchKeyword: searchKeyword,
        searchWords: searchWords,
    };


    const validationSchema = yup.object({
        searchKeyword: yup.string('').nullable(),
        searchWords: yup.string('').trim().nullable(),
    });

    const formik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { setSubmitting }) => {
            setSubmitting(true);
            searchList(values);
            setSubmitting(false);
        },
    });

    const handleDown = (event, params) => {
        event.ignore = true;
        const link = document.createElement('a');
        link.href = params.row.wrfileUrl;
        link.download = true;
        link.target = "_blank";
        link.rel = "noopener noreferrer"

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
    }

    const columns = useMemo(
        () => [
            {
                field: 'id',
                headerName: 'ID',
                hide: true,
                type: 'string',
                editable: false,
                sortable: false,
            },
            {
                field: 'wrUuid',
                hide: true,
                type: 'string',
                editable: false,
                sortable: false,
            },

            {
                field: 'wrTitle',
                headerName: '제목',
                minWidth: 300,
                flex: 1,
                type: 'string',
                editable: false,
                align: 'left',
                headerAlign: 'left',
                disableClickEventBubbling: true,
                renderCell: (params) => (
                    <div>
                        {params.value}
                        {params.row.wrFileCnt !== '0' && (
                            <Button variant="contained" size="small" sx={{ mx: 2 }} onClick={(e) => handleDown(e, params)}>download</Button>
                        )}
                    </div>
                )
            },
            {
                field: 'crtNm',
                headerName: '작성자',
                minWidth: 80,
                flex: 0.3,
                type: 'string',
                editable: false,
            },
            {
                field: 'crtDt',
                headerName: '작성일',
                minWidth: 150,
                flex: 0.8,
                type: 'string',
                editable: false,
            },
        ],
        [],
    );

    const handleRowClick = (e, param) => {
        if (!e.ignore) {
            selectedNotice(param.row);
        }

    };
    return (
        <div>
            <NoticeListBox formik={formik} />
            <NoticeList
                columns={columns}
                rows={notices}
                loading={loading}
                handleRowClick={handleRowClick}
                columnVisibilityModel={{
                    // Hide columns status and traderName, the other columns will remain visible
                    wrUuid: false,
                //    traderName: false,
                  }}

            />
        </div>
    )
}

export default NoticeListContainer